export enum MKRttEstimationMethod {
    /**
     * Uses the median of the round-trip-times measured for the previous downloads.
     * 
     * May perform better on low-performant devices.
     */
    Median = "median",

    /**
     * Uses the weighted average of the round-trip-times measured for the previous downloads, with newest samples having the highest weights.
     */
    WeightedAverage = "weightedaverage"
}